import * as React from "react";
import * as StatusMessages from "../../../../constants/StatusMessages";
import StatusMessage from "../../../presentational/StatusMessage";
import { FormattedMessage } from "react-intl";
class Wrapper extends React.Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div className="wrapper wrapper_narrow login-wrapper">
				
				<StatusMessage isError={!this.props.isSuccessLogout} isSuccess={this.props.isSuccessLogout} isActive={this.props.isSuccessLogout !== null ? true : false} customMessage={this.props.isSuccessLogout ? StatusMessages.AUTH.LOGOUT : StatusMessages.AUTH.LOGOUT_401} domain="auth" willPersist/>
				<StatusMessage isError={!this.props.authIsSuccess} isSuccess={this.props.authIsSuccess} isActive={this.props.authIsSuccess !== null ? true : false} customMessage={StatusMessages.AUTH.SUCCESS_MESSAGE_PASSWORD_FORGOT} domain="auth" willPersist/>

				<StatusMessage isSuccess isActive={this.props.isPasswordResetSuccess || false} customMessage={StatusMessages.AUTH.SUCCESS_MESSAGE_PASSWORD_RESET} domain="auth-password-reset" willPersist/>

				<h1 className="u-isVisuallyHidden js-pageHeader">
					<FormattedMessage id="login.header" defaultMessage="Login or Create New Account"/>
				</h1>

				{this.props.children}
			</div>);
    }
    /**
     * React lifecycle method. Fires once before the component is removed from the DOM.
     *
     * @method componentWillUnmount
     * @private
     */
    componentWillUnmount() {
        /* If the user leaves this page, make sure the modal is closed */
        this.props.closeModal({ modalId: "", triggerId: "" });
    }
}
export default Wrapper;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Login/Wrapper.tsx